// CreateAdmin.tsx
import React, { useState, useRef } from "react";

import {
  Modal,
  TextInput,
  PasswordInput,
  Text,
  Button,
  Group,
  Select,
  NumberInput,
  Checkbox,
} from "@mantine/core";
import { DateTimePicker, DateInput } from "@mantine/dates";
import { Dropzone } from "@mantine/dropzone";
import { RowDataDealerRebate } from "./types";
import { IconPhoto } from "@tabler/icons-react";
import "@mantine/dates/styles.css";
import moment from "moment";
import classes from "./DealerRebate.module.css";

interface CreateRebateProps {
  isVisible: boolean;
  onClose: () => void;
  onAddRebate: (newRebate: RowDataDealerRebate) => void;
}

const CreateRebateModal: React.FC<CreateRebateProps> = ({
  isVisible,
  onClose,
  onAddRebate,
}) => {
  const [newRebate, setNewRebate] = useState<RowDataDealerRebate>({
    id: 0,
    uid: "",
    startDate: "",
    endDate: "",
    percentage: 0,
    amount: 0,
    createdAt: "",
    isIssued: false,
  });

  const [isConfirmed, setIsConfirmed] = useState(false)

  const handleAddRebate = () => {
    // Check if any field is empty
    // console.log(newVoucher);

    if (
      !newRebate.startDate ||
      !newRebate.endDate ||
      !newRebate.percentage
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all of the required details");
      return;
    }

    // console.log(newVoucher);

    if (
        new Date(newRebate.startDate).getTime() ==
        new Date(newRebate.endDate).getTime()
      ) {
        alert("End date cannot be same as Start date");
        return;
      }

    if (
      new Date(newRebate.startDate).getTime() >
      new Date(newRebate.endDate).getTime()
    ) {
      alert("End date cannot be before Start date");
      return;
    }

    if(!isConfirmed){
        alert("Please check the checkbox to confirm rebate creation");
        return;
    }

    // Validation passed, proceed with adding the customer
    onAddRebate({
      ...newRebate,
    //   action: "Add",
    });

    setNewRebate({
        id: 0,
        uid: "",
        startDate: "",
        endDate: "",
        percentage: 0,
        amount: 0,
        createdAt: "",
        isIssued: false,
    });
    setIsConfirmed(false)

    onClose();
  };


  const handleClose = () => {
    // Clear inputs and reset state
    setNewRebate({
        id: 0,
        uid: "",
        startDate: "",
        endDate: "",
        percentage: 0,
        amount: 0,
        createdAt: "",
        isIssued: false,
      });
      setIsConfirmed(false)
    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      opened={isVisible}
      onClose={handleClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Rebate
        </div>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddRebate();
        }}
      >
        <DateInput
        //   valueFormat="YYYY-MM-DD HH:mm:ss.SSS"
        //   dropdownType="modal"
          label="Start Date"
          placeholder="Pick date"
          mb="sm"
          required
          minDate={new Date()}
          onChange={(e) =>
            setNewRebate({
              ...newRebate,
              startDate: moment(e).format("YYYY-MM-DD HH:mm:ss.SSS") ?? "",
            })
          }
        />
        <DateInput
        //   valueFormat="YYYY-MM-DD HH:mm:ss.SSS"
        //   dropdownType="modal"
          label="End Date"
          placeholder="Pick date"
          mb="sm"
          required
          minDate={!newRebate.startDate ? new Date() : new Date(newRebate.startDate)}
          onChange={(e) =>
            setNewRebate({
              ...newRebate,
              endDate: moment(e).format("YYYY-MM-DD HH:mm:ss.SSS") ?? "",
            })
          }
        />
        <NumberInput
          label="Rebate Percentage"
          placeholder="Input number of vouchers"
          mb="sm"
          required
          allowNegative={false}
          allowDecimal={false}
          value={newRebate.percentage}
          onChange={(e) => setNewRebate({ ...newRebate, percentage: e })}
          min={1}
          max={999}
        />

        <Checkbox
            label="I confirmed this rebate creation"
            description="Rebate cannot be edited after it is created"
            checked={isConfirmed}
            onChange={(event) => setIsConfirmed(event.currentTarget.checked)}
            mt={'xl'}
        />

        <Group className={classes.buttonBottom}>
          <Button onClick={() => handleClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button type="submit" className={classes.buttonSaveChanges}>
            Submit
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default CreateRebateModal;
